export default __webpack_public_path__ + "static/media/Constancia-entrega-documentos-bolivariano.206d05f7.docx";